import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from '../../firebaseConfig'
import styles from '../../css/terms.module.css';

// 개인(신용)정보 제 3자 제공현황
const PrivacyThirdParty = () => {
    const [detailData, setDetailData] = useState();

    const termsCollectionRef = collection(db, "privacy_third_party");
    const getTerms = async () => {
        const q = query(termsCollectionRef, orderBy("title", "desc"))
        const data = await getDocs(q);
        const termsData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        console.log(termsData)
        setDetailData(termsData[0])
    }
    useEffect(() => {
        getTerms();
    }, [])

    // 테이블 가로스크롤을 위한 코드
    useEffect(() => {
        if (!detailData) return;
        const root = document.querySelector(`.${styles.container}`);
        root?.querySelectorAll('table').forEach((table) => {
            if (table.parentElement?.classList.contains(styles.table_scroll)) return;
            const wrap = document.createElement('div');
            wrap.className = styles.table_scroll;
            table.replaceWith(wrap);
            wrap.appendChild(table);
        });
    }, [detailData]);

    return (
        <section className={styles.terms}>
            <main className='wrp'>
                <h3>개인(신용)정보 제 3자 제공현황</h3>

                <div className={styles.container} >
                    {detailData && <article dangerouslySetInnerHTML={{ __html: detailData.content }}>
                        { }
                    </article>}
                </div>
            </main>
        </section >
    );

};

export default PrivacyThirdParty;
